import { ModelBase, Property } from '@skylab-shared/core';

export class ProductPriceModel extends ModelBase {

    @Property()
    public net: number;

    @Property()
    public gross: number;

    @Property()
    public currencyId: number;
}
